(()=> {
  const form = document.querySelector('.footer__newsletter'),
        input = form.querySelector('.newsletter-form__field__input'),
        errorMessage = form.querySelector('.newsletter-form__messageError'),
        button = form.querySelector('.footer__newsletter__button'),
        field = document.querySelector('.newsletter-form__field-wrapper .field');

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validate = (e) => {
    const email = input.value;

    if (validateEmail(email)) {
      if (errorMessage) {
        errorMessage.classList.add('newsletter-form__message--hidden');
      }
    } else {
      e.preventDefault();
      if (errorMessage) {
        errorMessage.classList.remove('newsletter-form__message--hidden');
        input.classList.add('newsletter-form__field__input--error');
        field.classList.add('field--error');
      }
    }
    return false;
  }

  if (button) {
    button.addEventListener('click', (e) => {
      validate(e);
    });
  }
})();